import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileHttpService } from '../../shared/http/file-http.service';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { DownloaderService } from './downloader.service';
import { BackupFile, TextBackupFile } from './';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BackupFileDownloaderService {
  constructor(
    private httpService: JsonHttpService,
    private downloaderServicer: DownloaderService,
    private fileHttpService: FileHttpService
  ) { }

  public downloadFile(fileIdentifier: string, fileType: string): Promise<void> {
    const options = {
      params: new HttpParams()
        .set('fileIdentifier', `${fileIdentifier}`)
        .set('fileType', `${fileType}`)
    };
    return this.httpService.get('api/backupfiles/download/get-download-token', options).toPromise()
      .then(token => this.downloaderServicer.downloadFile(token));
  }

  public getFilename(fileIdentifier: string, fileType: string, useGenericErrorHandling?: boolean): Promise<string> {
    const options = {
      params: new HttpParams()
        .set('fileIdentifier', `${fileIdentifier}`)
        .set('fileType', `${fileType}`)
    };
    return this.httpService.get('api/backupfiles/download/get-filename', options, useGenericErrorHandling).toPromise();
  }

  public getFileText(fileIdentifier: string, fileType: string, includeText: boolean): Promise<TextBackupFile> {
    const options = {
      params: new HttpParams()
        .set('fileIdentifier', `${fileIdentifier}`)
        .set('fileType', `${fileType}`)
    };
    if (includeText) {
      return this.httpService.getTyped<TextBackupFile>('api/backupfiles/download/get-file-text', options).toPromise();
    }
    else {
      return this.httpService.getTyped<BackupFile>('api/backupfiles/download/get-file-info', options).pipe(
        map((file: Partial<BackupFile>) => {
          delete file.FileData;
          return { ...file, FileText: null } as TextBackupFile;
        })
      ).toPromise();
    }
  }

  public getFileInfo(fileIdentifier: string, fileType: string): Promise<BackupFile> {
    const options = {
      params: new HttpParams()
        .set('fileIdentifier', `${fileIdentifier}`)
        .set('fileType', `${fileType}`)
    };
    return this.httpService.get('api/backupfiles/download/get-file-info', options).toPromise();
  }

  public downloadMiscFile(fileIdentifier: string): Promise<void> {
    const options = { params: new HttpParams().set('fileIdentifier', `${fileIdentifier}`) };
    return this.httpService.get('api/configurationbackupfiles/get-download-token', options).toPromise()
      .then(token => this.downloaderServicer.downloadFile(token));
  }

  public getMiscFilename(fileIdentifier: string): Promise<string> {
    const options = { params: new HttpParams().set('fileIdentifier', `${fileIdentifier}`) };
    return this.httpService.get('api/configurationbackupfiles/get-filename', options).toPromise();
  }

  public uploadMiscFile(file: File, fileType: string, existingFileIdentifier?: string): Promise<string> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise<string>((resolve, reject) => {

      if (file) {
        const options = { params: new HttpParams() };
        if (existingFileIdentifier) {
          options.params = options.params.set('existingFileIdentifier', existingFileIdentifier);
        }
        this.fileHttpService.upload<string>('/api/configurationbackupfiles/upload-file', [file], options).then((result) => {
          resolve(result as string);
        });
      }
      else {
        resolve(null);
      }
    });
  }
}
